// packages
import 'intersection-observer';
import yall from 'yall-js';
import debounce from 'lodash.debounce';

// local imports
import { AdLoader } from './ads/loader';
import { loadJsonScript } from './utils/load-json-script';
import { createBase } from './utils/d3-base';

// d3
import { select } from 'd3-selection';
import { scaleLinear, scaleBand } from 'd3-scale';
import { line } from 'd3-shape';
import { range } from 'd3-array';

// Kickstart the ads
const adLoader = new AdLoader({ adSection: window.AD_SECTION });
adLoader.init();

// Kickstart the lazy image loading
document.addEventListener('DOMContentLoaded', yall);

// Write your code!
const rawData = loadJsonScript('line-data');

function boot(data) {
  const cleanedData = data
    .map((d) => ({
      cycle: +d.cycle + 1,
      total: +d.total,
    }))
    .filter((d) => d.cycle >= 2004);

  const container = select('#line-chart');
  render();

  function render() {
    container.html('');

    const parent = container.node();
    const containerWidth = parent.offsetWidth;
    const isMobile = containerWidth <= 768;
    const isTiny = containerWidth <= 400;

    const margin = { top: 10, right: 20, bottom: 25, left: 20 };

    const { g, x, y, width, height, xAxis, yAxis, drawAxis } = createBase({
      container,
      height: 200,
      x: scaleBand(),
      y: scaleLinear(),
      margin: margin,
    });

    g.attr('class', 'axes');
    // set up our scales
    x.domain(range(cleanedData.length)).range([0, width]).padding(0.1);
    y.domain([0, 760000000]).range([height, 0]);

    // set up the line drawer
    const lineGenerator = line()
      .x((d) => x(d.cycle))
      .y((d) => y(d.total));

    xAxis
      .tickValues([0, cleanedData.length - 1])
      .tickFormat((d) => cleanedData[d].cycle);

    drawAxis();
    g.selectAll('.axis--y').remove();
    g.selectAll('.domain').remove();
    g.selectAll('.axis--x .tick line').remove();

    g.selectAll('rect')
      .data(cleanedData)
      .enter()
      .append('rect')
      .attr('x', (d, i) => x(i))
      .attr('y', (d) => y(d.total))
      .attr('height', (d) => y(0) - y(d.total))
      .attr('width', x.bandwidth())
      .attr('fill', (d) => (d.cycle != 2020 ? '#f6a0a1' : '#d94f54'));

    // g.append('path')
    //   .datum(cleanedData)
    //   .attr('class', 'line')
    //   .attr('fill', 'none')
    //   .attr('stroke', '#1281aa')
    //   .attr('stroke-width', '4')
    //   .attr('d', lineGenerator);
    //
    // g.append('circle')
    //   .datum(cleanedData[cleanedData.length - 1])
    //   .attr('class', 'focus')
    //   .attr('fill', '#1281aa')
    //   .attr('r', 7)
    //   .attr('cx', (d) => x(d.cycle))
    //   .attr('cy', (d) => y(d.total));

    g.append('text')
      .classed('anno', true)
      .attr('x', width / 2)
      .attr('y', height + 18)
      .attr('text-anchor', 'middle')
      .text('Money raised');
  }

  return render;
}

// Boot charts
const makeChart = boot(rawData);
window.addEventListener('resize', debounce(makeChart, 300));
